// resources/js/Components/Welcome.jsx
import React from 'react';
import { Head, Link, usePage } from '@inertiajs/react';
import LanguageSwitcher from '@/Components/LanguageSwitcher'; 
import PrimaryButton from '@/Components/PrimaryButton.jsx';
import ApplicationLogo from '@/Components/ApplicationLogo';
import CookieConsent from '@/Components/CookieConsent';

//import { usePaddlePurchase } from '@/Hooks/usePaddlePurchase';

export default function Welcome({ courses }) {
    const { auth, app, lang } = usePage().props;

    const __ = (key) => lang?.messages?.[key] || key;
    const appName = app ? app.name : 'Agasaja Academy';  


    const currentYear = new Date().getFullYear();


    // Instanciamos el hook de compra
    //const { handlePurchase } = usePaddlePurchase();
    

    return (
        <div className="min-h-screen bg-white">
            <Head title={appName} />
            
            {/* NAV ÚNICA */}
            <nav className="bg-white border-b border-gray-100 sticky top-0 z-50 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16 items-center">
                        <div className="flex items-center">
                            <Link href="/" className="flex shrink-0">
                                <ApplicationLogo className="h-8 w-auto text-indigo-600" />
                            </Link>
                            <span className="hidden sm:block ml-3 text-xl font-bold text-indigo-600">
                                {appName}
                            </span>
                        </div>
                        
                        <div className="flex items-center space-x-2 sm:space-x-4">
                            <LanguageSwitcher />                            
                            {auth.user ? (
                                <Link href={route('dashboard')} className="text-sm font-bold text-indigo-600">
                                    Dashboard
                                </Link>
                            ) : (
                                <>
                                    <Link href={route('login')} className="text-xs sm:text-sm font-semibold text-gray-700">
                                        {__('login')}
                                    </Link>
                                    <Link href={route('register')}>
                                    {/* Botón más compacto en móvil */}
                                        <PrimaryButton className="text-[10px] sm:text-xs px-2 py-1 sm:px-4 sm:py-2">
                                            {__('register')}
                                        </PrimaryButton>
                                    </Link>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </nav>

            {/* SECCIÓN HERO */}
            <div className="bg-gray-50 py-10 sm:py-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
                    {/* Ajustamos el tamaño del texto: 3xl en móvil, 6xl en escritorio */}
                    <h1 className="text-3xl sm:text-5xl md:text-6xl font-black tracking-tight text-gray-900 leading-tight">
                        {__('master_spanish')}
                    </h1>
                    <p className="mt-4 text-lg sm:text-xl text-gray-500 max-w-2xl mx-auto">
                        {__('stop_memorizing_rules')}
                    </p>
                    <div className="mt-8">
                        <Link href={route('register')}>
                            <button className="w-full sm:w-auto px-8 py-4 bg-indigo-600 hover:bg-indigo-700 text-white text-lg font-bold rounded-2xl transition-all shadow-lg active:scale-95">
                                {__('start_learning_for_free')}
                            </button>
                        </Link>
                    </div>
                </div>
            </div>

            {/* GRID DE CURSOS */}
            <div className="max-w-7xl mx-auto py-12 px-6 lg:px-8">
                <h2 className="text-2xl sm:text-3xl font-black text-gray-900 text-center mb-8">
                    {__('our_available_courses')}
                </h2>
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {courses.map((course) => (
                        <div key={course.id} className="group bg-white p-6 rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-all">
                            <h3 className="text-xl font-bold text-gray-900">
                                {__(course.title)} 
                                <span className="text-xs font-medium ml-2 text-indigo-600 bg-indigo-50 px-2 py-1 rounded-full">
                                    {course.level}
                                </span>
                            </h3>
                            <p className="mt-2 text-sm text-gray-500 leading-relaxed">
                                {__(course.description)}
                            </p>
                            <Link href={route('lessons.show', { chapterId: 1 })} className="mt-4 inline-flex items-center text-sm font-bold text-indigo-600">
                                {__('check_out_the_course')} &rarr;
                            </Link>
                        </div>
                    ))}
                </div>
            </div>

            {/* FOOTER ACTUALIZADO PARA CUMPLIMIENTO CON PADDLE */}
            <footer className="bg-white border-t border-gray-100 mt-20 py-12 px-6">
                <div className="max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start text-center md:text-left">
                        
                        {/* Columna 1: Branding y Propósito */}
                        <div className="flex flex-col items-center md:items-start">
                            <ApplicationLogo className="h-8 w-auto text-indigo-600 mb-4" />
                            <p className="text-sm text-gray-500 max-w-xs leading-relaxed">
                                {__('footer_mission') || 'Plataforma educativa interactiva para el dominio del idioma español mediante la práctica constante.'}
                            </p>
                        </div>

                        {/* Columna 2: Enlaces Legales (Crítico para Paddle) */}
                        <div className="flex flex-col space-y-3">
                            <h4 className="text-sm font-black text-gray-900 uppercase tracking-widest mb-2">
                                {__('legal_information') || 'Información Legal'}
                            </h4>
                            <Link href={route('terms')} className="text-sm text-gray-500 hover:text-indigo-600 transition">
                                {__('terms_conditions') || 'Términos y Condiciones'}
                            </Link>
                            <Link href={route('privacy')} className="text-sm text-gray-500 hover:text-indigo-600 transition">
                                {__('privacy_policy') || 'Política de Privacidad'}
                            </Link>
                            <Link href={route('refunds')} className="text-sm text-gray-500 hover:text-indigo-600 transition">
                                {__('refund_policy') || 'Política de Reembolso'}
                            </Link>
                        </div>

                        {/* Columna 3: Productos y Precios */}
                        <div className="flex flex-col space-y-3">
                            <h4 className="text-sm font-black text-gray-900 uppercase tracking-widest mb-2">
                                {__('products_services') || 'Productos'}
                            </h4>
                            <Link href={route('pricing')} className="text-sm text-gray-500 hover:text-indigo-600 transition">
                                {__('pricing_plans') || 'Planes y Precios'}
                            </Link>
                            <Link href={route('contact')} className="text-sm text-gray-500 hover:text-indigo-600 transition">
                                {__('customer_support') || 'Atención al Cliente'}
                            </Link>
                        </div>
                    </div>

                    {/* Barra de Derechos de Autor Final */}
                    <div className="mt-12 pt-8 border-t border-gray-50 text-center">
                        <p className="text-[11px] text-gray-400 font-medium">
                            &copy; {currentYear} {appName}. {__('all_rights_reserved')}. 
                           {/** <span className="block mt-1 sm:inline sm:mt-0 sm:ml-2">
                                {__('crafted_in_bolivia') || 'Santa Cruz de la Sierra, Bolivia.'}
                            </span> */} 
                        </p>
                    </div>
                </div>
            </footer>
            {/* 6. Cookies consent*/}
            <CookieConsent />             
        </div>
    );
}